export const transactionTypes = [
    { value: "DEBIT", name: "Débito" },
    { value: "CREDIT", name: "Crédito" },
  ]